import type { OutgoingInfo } from '../types';
import { OutgoingMessage } from '../types';

import type { IOutgoingMessage } from './types';

export const CrossOriginCommunicationDefaultSender = (
  message: OutgoingMessage,
  info?: OutgoingInfo
): IOutgoingMessage | null => {
  let payload;

  switch (message) {
    case OutgoingMessage.GameActive:
    case OutgoingMessage.GameReady:
      payload = message;
      break;
    case OutgoingMessage.CloseContainer:
    case OutgoingMessage.GameLoadEnd:
    case OutgoingMessage.GameLoadStart: // 1st message sent - no table config data
    case OutgoingMessage.GameQuit:
    case OutgoingMessage.OpenCashier:
    case OutgoingMessage.RealityCheckContinue:
    case OutgoingMessage.RealityCheckQuit:
    case OutgoingMessage.RealityCheckShown:
    case OutgoingMessage.RoundEnd:
    case OutgoingMessage.RoundStart:
      payload = { sender: info?.tableId ?? '' };
      break;
    default:
      return null;
  }
  return {
    name: message,
    data: payload,
  };
};
